function ShowUpdateSkuDataModal(This, title) {
  This.$refs.updateSkuDataModal.info = {
    title,
    visible: true,
    ratio: null,
    addNum: null,
    radioValue: "add",
  };
}

function UpdateSkuData(This, data) {
  This.$message.success(`成功修改商品的${data.title}`);
  data.ratio = Number(data.ratio) || 0;
  data.addNum = Number(data.addNum) || 0;
  data.value = Number(data.value) || 0;
  const map = {
    价格: { key: "price", originKey: "origin_price", fixedNum: 2 },
    库存: { key: "stock_num", originKey: "origin_stock", fixedNum: 0 },
  };
  const { key, originKey, fixedNum } = map[data.title];
  This.goodsItem.skuList.map((item) => {
    if (data.radioValue === "add") {
      const val = data.ratio ? item[originKey] * data.ratio : item[originKey];
      item[key] = +(val + data.addNum).toFixed(fixedNum);
    } else item[key] = data.value || item[key];
    // 修改来源库存是0的时候
    if (data.stock && !item.origin_stock) item.stock_num = data.stock;
  });
  This.$refs.updateSkuDataModal.info.visible = false;
}

function ChangeSkuName(This, level, obj) {
  This.goodsItem.skuList.map((item) => {
    if (item.sell_properties[level].value_name === obj.old_value_name || !item.sell_properties[level].value_name)
      item.sell_properties[level].value_name = obj.value_name;
  });
  obj.old_value_name = obj.value_name;
}

function DeleteSku(This, item, value, index, level) {
  if (item.values.length === 1) {
    This.goodsItem.skuList.map((item) => {
      item.sell_properties[level].value_name = "";
    });
  } else {
    let name = "";
    if (value && typeof value === "object") {
      for (let i = 0; i < value.length; i++) {
        name += value[i] + (item.values[index].unit_name_arr?.[i] || "") + (item.values[index].suffix_arr?.[i] || "");
      }
    } else name = value;
    This.tableInfo.list = This.goodsItem.skuList = This.goodsItem.skuList.filter((i) => {
      // 说明是匹配上了的 或者 不是要求必选的规格值
      if (item.values[index].value_id !== null) return i.sell_properties[level].value_name !== name;
      return i.sell_properties[level].value_name !== (name || item.values[index].top_value_name);
    });
  }
  item.values.splice(index, 1);
  item.images?.splice(index, 1);
  This.$message.success("删除商品的规格值成功");
}

// 添加SKU
function AddSkuValue(This, item, index) {
  const IsMeasure = item.measureTemplateList?.length;
  const lastItem = item.values[item.values.length - 1];
  const IsPassMeasure =
    lastItem?.isNeedUnitCount && lastItem.isNeedUnitCount === lastItem.unit_id_arr?.filter((option) => option).length;
  if (item.values[0] && ((!IsMeasure && !lastItem?.value_name) || (IsMeasure && !IsPassMeasure)))
    return This.$message.warn("请先将上一个规格值填写完");
  const firstNoCompareSku = This.goodsItem.noCompareSkuList[0] || This.goodsItem.skuList[0];
  const { skuInfo, skuList } = This.goodsItem;
  // 添加第一级
  if (index === 0) {
    // 如果没有第二级
    if (!skuInfo[1]?.values?.length) {
      skuList.push({
        origin_price: firstNoCompareSku.origin_price,
        origin_stock_num: 100,
        outer_sku_id: "",
        price: firstNoCompareSku.price,
        stock_num: firstNoCompareSku.stock_num,
        sell_properties: [
          {
            property_name: item.property_name,
            value_name: "",
          },
        ],
      });
    } else {
      for (let option of skuInfo[1].values) {
        skuList.push({
          origin_price: firstNoCompareSku.origin_price,
          origin_stock_num: 100,
          outer_sku_id: "",
          price: firstNoCompareSku.price,
          stock_num: firstNoCompareSku.stock_num,
          sell_properties: [
            {
              property_name: item.property_name,
              value_name: "",
            },
            {
              property_name: option.property_name,
              value_name: typeof option.value_name === "object" ? option.value_name[1] : option.value_name,
            },
          ],
        });
      }
    }
  }
  // 添加第二级
  else if (index === 1) {
    // 如果有第一级
    if (skuInfo[0]?.values?.length) {
      // 如果只有第一级有数据的情况
      if (skuList[0]?.sell_properties?.length === 1) {
        // 给列表里每个sku加上第二级参数
        for (let option of skuList) {
          option.sell_properties.push({
            property_name: item.property_name,
            value_name: "",
          });
        }
      } else {
        for (let option of skuInfo[0].values) {
          skuList.push({
            origin_price: firstNoCompareSku.origin_price,
            origin_stock_num: 100,
            outer_sku_id: "",
            price: firstNoCompareSku.price,
            stock_num: firstNoCompareSku.stock_num,
            sell_properties: [
              {
                property_name: option.property_name,
                value_name: typeof option.value_name === "object" ? option.value_name[0] : option.value_name,
              },
              {
                property_name: item.property_name,
                value_name: "",
              },
            ],
          });
        }
      }
    } else return This.$message.warn("请先添加 1 个主规格");
  }
  item.values.push({ value_name: "", property_name: item.property_name, isAdd: true });
  !index && item.images.push({});
}

// 检查规格值是否重复
function CheckSkuIsRepeat(item, value, index) {
  if (item.values?.length) {
    for (let i in item.values) {
      const sku = item.values[i];
      sku.errMsg = "";
      if (i != index && value && sku.value_name === value) {
        item.values[index].errMsg = `规格值【${value}】已经存在`;
        break;
      }
    }
  }
}

export default {
  ShowUpdateSkuDataModal,
  UpdateSkuData,
  ChangeSkuName,
  DeleteSku,
  AddSkuValue,
  CheckSkuIsRepeat,
};
